import { getApp, isRunningInMetaOSHub } from 'owa-config';
import { isOpxHostInitialized } from 'owa-opx';

/**
 * Identifies the dedicated hosted MyOutlook app, with OPX initialization
 * taking precedence when both hosts could match.
 */
export function isMyOutlookMetaOsHost(): boolean {
    return !isOpxHostInitialized() && isRunningInMetaOSHub() && getApp() === 'MyOutlook';
}
